import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { GoogleLogo } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const HERO_IMG =
    "https://images.unsplash.com/photo-1772001936267-b6058748eff4?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85";

export default function Login() {
    const [config, setConfig] = useState({ allowed_domains: [] });

    useEffect(() => {
        http.get("/auth/config")
            .then((r) => setConfig(r.data))
            .catch(() => null);
    }, []);

    const startGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
            redirectUrl,
        )}`;
    };

    const allowed = config.allowed_domains?.[0] || "ingartek.com";

    return (
        <div className="min-h-screen grid lg:grid-cols-2">
            {/* Left — Login form */}
            <div className="flex flex-col justify-between p-10 lg:p-16 bg-white">
                <div>
                    <div className="font-display text-3xl font-bold tracking-tight">
                        Ingartek
                    </div>
                    <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mt-1">
                        Portal
                    </div>
                </div>

                <div className="max-w-sm w-full mx-auto lg:mx-0">
                    <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-3">
                        Bienvenido de nuevo
                    </div>
                    <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tight text-slate-950 leading-[1.05]">
                        Accede a tu
                        <br />
                        espacio de trabajo.
                    </h1>
                    <p className="text-sm text-slate-600 mt-4">
                        Inicia sesión con tu cuenta corporativa{" "}
                        <span className="font-mono text-slate-800">@{allowed}</span> para
                        registrar tu jornada, gestionar vacaciones e informes.
                    </p>

                    <Button
                        onClick={startGoogle}
                        className="w-full mt-8 h-12 rounded-sm bg-[#002BAF] hover:bg-[#001F82] text-white text-sm font-medium"
                        data-testid="login-google-btn"
                    >
                        <GoogleLogo size={18} weight="bold" className="mr-2" />
                        Continuar con Google
                    </Button>
                </div>

                <div className="text-xs text-slate-500 mt-12">
                    © {new Date().getFullYear()} Ingartek · Portal — registro de
                    jornada
                </div>
            </div>

            {/* Right — Hero image */}
            <div className="hidden lg:block relative">
                <img
                    src={HERO_IMG}
                    alt="Modern corporate office"
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-slate-950/30" />
                <div className="absolute bottom-10 left-10 right-10 text-white">
                    <div className="text-[10px] uppercase tracking-[0.2em] text-slate-300">
                        Registro de jornada · Cumplimiento RD-Ley 8/2019
                    </div>
                    <div className="font-display text-3xl font-bold tracking-tight mt-3 max-w-md">
                        Cada hora, en su sitio.
                    </div>
                </div>
            </div>
        </div>
    );
}
